import React, { useEffect, useState } from "react";
import axios from "axios";

// const API = "http://localhost:5050/api/v1/admin/languages";

export default function LanguageManagement() {
  const [languages, setLanguages] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

//   const token = localStorage.getItem("token");

//   const config = {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };

  // Fetch Languages
  const fetchLanguages = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/v1/admin/languages");
      setLanguages(data.data);
    } catch (err) {
      alert(err.response?.data?.message || "Error fetching languages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLanguages();
  }, []);

  // Create or Update Language
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) return alert("Language name required");

    try {
      setLoading(true);

      if (editId) {
        await axios.put(`/api/v1/admin/languages/${editId}`, { name });
        setEditId(null);
      } else {
        await axios.post("/api/v1/admin/languages", { name });
      }

      setName("");
      fetchLanguages();
    } catch (err) {
      alert(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Delete Language
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      setLoading(true);
      await axios.delete(`/api/v1/admin/languages/${id}`);
      fetchLanguages();
    } catch (err) {
      alert(err.response?.data?.message || "Delete failed");
    } finally {
      setLoading(false);
    }
  };

  const filteredLanguages = languages.filter((lang) =>
    lang.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Language Management</h1>

      {/* Create / Edit Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow rounded-xl p-6 mb-8"
      >
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="Enter language name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border rounded-lg px-4 py-2 w-full"
          />

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg"
          >
            {editId ? "Update" : "Add"}
          </button>
        </div>
      </form>

      {/* Search */}
      <input
        type="text"
        placeholder="Search language..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border rounded-lg px-4 py-2 mb-4 w-full"
      />

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-6 text-center">Loading...</div>
        ) : (
          <table className="w-full text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-4">#</th>
                <th className="p-4">Language Name</th>
                <th className="p-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLanguages.length === 0 ? (
                <tr>
                  <td colSpan="3" className="p-6 text-center">
                    No languages found
                  </td>
                </tr>
              ) : (
                filteredLanguages.map((lang, index) => (
                  <tr key={lang._id} className="border-t">
                    <td className="p-4">{index + 1}</td>
                    <td className="p-4">{lang.name}</td>
                    <td className="p-4 text-right space-x-2">
                      <button
                        onClick={() => {
                          setName(lang.name);
                          setEditId(lang._id);
                        }}
                        className="bg-yellow-500 text-white px-4 py-1 rounded"
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => handleDelete(lang._id)}
                        className="bg-red-600 text-white px-4 py-1 rounded"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}